export namespace LuxonDateStringFormats {
    export const DATE_HOUR_MINUTE_SECOND = 'dd.MM.yyyy — HH:mm:ss';
    export const DATE_HOUR_MINUTE = 'dd.MM.yyyy — HH:mm';
    export const DATE = 'dd.MM.yyyy';
    export const HOUR_MINUTE = 'HH:mm';
}
